export const getSize = (element: { target: { naturalHeight: number, naturalWidth: number } }): { height: number, width: number } => {
  return {
    height: element.target.naturalHeight,
    width: element.target.naturalWidth,
  };
}

export const createImage = (base64: string) => {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.src = base64;
  });
}

export const downloadImage = (imageName: string, imageSrc: string, imageWidth: number, imageHeight: number, canvasWidth: number, canvasHeight: number, positionX: number, positionY: number) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext("2d");

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
    
  createImage(imageSrc).then((image: any) => {
    const newSize = imageResize(imageWidth, imageHeight, canvasWidth, canvasHeight);

    positionX = positionX ? positionX : (canvasWidth - newSize.width) / 2;
    positionY = positionY ? positionY : (canvasHeight - newSize.height ) / 2;

    context.drawImage(image, positionX, positionY, newSize.width, newSize.height);
  }).then(() => {
    const downloadLink = document.createElement("a");
    downloadLink.href = canvas.toDataURL('image/jpeg');
    downloadLink.download = imageName;
    downloadLink.click();
  });
}

export const getBlobImage = async (imageSrc: string, imageWidth: number, imageHeight: number, canvasWidth: number, canvasHeight: number, positionX: any, positionY: any) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext("2d");
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  return createImage(imageSrc).then((image: any) => {
    const newSize = imageResize(imageWidth, imageHeight, canvasWidth, canvasHeight);
    
    const newPositionX = positionX ? positionX : (canvasWidth - newSize.width) / 2;
    const newpositionY = positionY ? positionY : (canvasHeight - newSize.height ) / 2;

    context.drawImage(image, newPositionX, newpositionY, newSize.width, newSize.height);
    return canvas.toDataURL('image/jpeg', [0.0, 1.0]).split(',')[1];
  })
}

export const imageResize = (widthImage: number, heightImage: number, widthCanvas: number, heightCanvas: number) => {
  const imageWidthProperties = widthImage / widthCanvas;
  const imageHeightProperties = heightImage / heightCanvas;

  const resizeProperties =
    imageWidthProperties < imageHeightProperties
      ? imageWidthProperties
      : imageHeightProperties;

  return {
    width: widthImage / resizeProperties,
    height: heightImage / resizeProperties,
  }; 
}


export const canvasResize = (image: any, context: { clearRect: (arg0: number, arg1: number, arg2: any, arg3: any) => void; save: () => void; drawImage: (arg0: any, arg1: number, arg2: number, arg3: any, arg4: any) => void; restore: () => void; }, canvasWidth: any, canvasHeight: any, offsetX = 0, offsetY = 0) => {
  context.clearRect(0, 0, canvasWidth, canvasHeight);
  context.save();
  context.drawImage(image, 0, 0, canvasWidth, canvasHeight);
  context.restore();
}

export const canvasRotate = (image: any, context: { clearRect: (arg0: number, arg1: number, arg2: any, arg3: any) => void; save: () => void; translate: (arg0: number, arg1: number) => void; rotate: (arg0: number) => void; drawImage: (arg0: any, arg1: number, arg2: number) => void; restore: () => void; }, canvasWidth: number, canvasHeight: number, imageWidth: number, imageHeight: number, rotationAngle: number) => {
    context.clearRect(0, 0, canvasWidth, canvasHeight);
    context.save();
    context.translate(canvasWidth / 2, canvasHeight / 2);
    context.rotate((rotationAngle * Math.PI) / 180);
    context.drawImage(image, -imageWidth / 2, -imageHeight / 2);
    context.restore();
}

export const canvasFlip = (image: any, context: { clearRect: (arg0: number, arg1: number, arg2: any, arg3: any) => void; save: () => void; translate: (arg0: number, arg1: number) => void; scale: (arg0: number, arg1: number) => void; drawImage: (arg0: any, arg1: number, arg2: number) => void; restore: () => void; }, canvasWidth: number, canvasHeight: number, imageWidth: number, imageHeight: number, isFlipVertical: any, isFlipHorizontal: any) => {
  context.clearRect(0, 0, canvasWidth, canvasHeight);
  context.save();
  context.translate(canvasWidth / 2, canvasHeight / 2);
  context.scale(isFlipVertical ? -1 : 1, isFlipHorizontal ? -1 : 1);
  context.drawImage(image, -imageWidth / 2, -imageHeight / 2);
  context.restore();
}


